import { IEnvironment } from './interface';
import { NG_APP_ENV } from '@web-nx-ng-tsc/shared-constant';

export const environment: IEnvironment = {
  loggingEnabled: true,
  production: true,
  name: 'production',
  local: false,
  phase: NG_APP_ENV,
}
